export default "__VITE_ASSET__C_$_kpOT__"